(function(module) {
    'use strict';

    module.config((msNavigationServiceProvider, envServiceProvider) => {
        const FEATURES = envServiceProvider.read('features');
        const SCHEDULES = _.get(FEATURES, 'schedules', false);

        msNavigationServiceProvider.saveItem('root', {
            title: 'Main Menu',
            group: true,
            weight: 1,
        });
        msNavigationServiceProvider.saveItem('root.help', {
            title: 'HELP',
            icon: 'fa-question-circle',
            state: 'root.help',
            weight: 0,
        });

        msNavigationServiceProvider.saveItem('root.home', {
            title: 'Home',
            icon: 'fa-home',
            state: 'root.home',
            weight: 2,
        });

        msNavigationServiceProvider.saveItem('root.apps', {
            title: 'Apps & Displays',
            group: true,
            weight: 3,
        });

        msNavigationServiceProvider.saveItem('root.store', {
            title: 'App Store',
            icon: 'fa-th-large',
            state: 'root.app-store',
            weight: 4,
        });

        msNavigationServiceProvider.saveItem('root.my-apps', {
            title: 'My Apps',
            icon: 'fa-paper-plane-o',
            state: 'root.my-apps',
            weight: 5,
        });

        // msNavigationServiceProvider.saveItem('root.display', {
        //     title: 'Displays & Groups',
        //     group: true,
        //     weight: 6,
        // });

        msNavigationServiceProvider.saveItem('root.displays', {
            title: 'Displays',
            icon: 'fa-television',
            state: 'root.displays',
            weight: 7,
        });

        msNavigationServiceProvider.saveItem('root.groups', {
            title: 'Groups',
            icon: 'fa-link',
            state: 'root.groups',
            weight: 8,

        });

        msNavigationServiceProvider.saveItem('root.playlists', {
            title: 'Playlists',
            icon: 'fa-list-ol',
            state: 'root.playlists',
            weight: 9,
        });

        if (FEATURES && SCHEDULES) {
            msNavigationServiceProvider.saveItem('root.schedules', {
                title: 'Schedules',
                icon: 'fa-calendar',
                state: 'root.schedules',
                weight: 10
            });
        }

        msNavigationServiceProvider.saveItem('connections', {
            title: 'Files & Integrations',
            group: true,
            weight: 11,
        });

        msNavigationServiceProvider.saveItem('connections.files', {
            title: 'Files',
            icon: 'fa-files-o',
            state: 'root.files',
            weight: 12,
        });

        msNavigationServiceProvider.saveItem('connections.integrations', {
            title: 'Integrations',
            icon: 'fa-code-fork',
            state: 'root.integrations',
            weight: 13,
        });

        msNavigationServiceProvider.saveItem('settings', {
            title: 'Organisation & Users',
            group: true,
            weight: 14,
        });

        msNavigationServiceProvider.saveItem('settings.users', {
            title: 'Users',
            icon: 'fa-users',
            state: 'root.users',
            weight: 15,
        });

        msNavigationServiceProvider.saveItem('settings.my-profile', {
            title: 'My Profile',
            icon: 'fa-user',
            state: 'root.my-profile',
            weight: 16,
        });

        msNavigationServiceProvider.saveItem('settings.my-account', {
            title: 'My Account',
            icon: 'fa-sitemap',
            state: 'root.my-account',
            weight: 17,
        });

        // TODO: show/hide based on role
        // msNavigationServiceProvider.saveItem('admin', {
        //     title: 'ADMIN',
        //     group: true,
        //     weight: 4
        // });
        //
        // msNavigationServiceProvider.saveItem('admin.accounts', {
        //     title: 'Accounts',
        //     icon: 'fa-users',
        //     state: 'root.admin.accounts',
        //     weight: 1
        // });

        msNavigationServiceProvider.saveItem('logout', {
            title: '---',
            group: true,
            weight: 19,
        });

        msNavigationServiceProvider.saveItem('logout.logout', {
            title: 'Logout',
            icon: 'fa-sign-out',
            state: 'logout',
            weight: 20,
        });

    });
})(angular.module('rocket.components'));
